import classNames from 'classnames';
import React from 'react';
import styles from "./course-card-details.module.css";
/**
 * Props for `CourseCardDetails` component.
 */

/**
 * Component for supporting information, details, and metadata about a course.
 *
 * @remarks
 *
 * Nodes passed via `metadata` are rendered with small text, in a horizontal row.
 *
 * Child nodes are rendered below the metadata row.
 */
export const CourseCardDetails = _ref => {
  let {
    metadata = [],
    children
  } = _ref;
  const metadataContent = metadata.filter(content => !!content).map((content, key) => /*#__PURE__*/React.createElement("span", {
    key: key,
    className: styles.row
  }, content));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, metadataContent.length > 0 && /*#__PURE__*/React.createElement("div", {
    "data-purpose": "course-meta-info",
    className: classNames(styles.row, styles['course-meta-info'], 'ud-text-xs')
  }, metadataContent), children);
};
//# sourceMappingURL=course-card-details.react-component.js.map